module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-timeline-container"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading-state"
  }, [_c('i', {
    staticClass: "el-icon-loading"
  }), _vm._v(" "), _c('p', [_vm._v("加载中...")])]) : (_vm.error) ? _c('div', {
    staticClass: "error-state"
  }, [_c('i', {
    staticClass: "el-icon-error"
  }), _vm._v(" "), _c('p', [_vm._v("加载失败")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.fetchData
    }
  }, [_vm._v("重新加载")])], 1) : [(_vm.orderTimeList.length === 0 && _vm.repayTimeList.length === 0) ? _c('div', {
    staticClass: "empty-state"
  }, [_c('i', {
    staticClass: "el-icon-document"
  }), _vm._v(" "), _c('p', [_vm._v("暂无时间线记录")])]) : [_c('div', {
    staticClass: "timeline-section"
  }, [_c('div', {
    staticClass: "section-header"
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "record-count"
  }, [_vm._v(_vm._s(_vm.orderTimeList.length) + "条记录")])]), _vm._v(" "), (_vm.currentStatus) ? _c('div', {
    staticClass: "custom-scroll-alert"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "scrolling-text-container"
  }, [_c('div', {
    staticClass: "scrolling-text"
  }, [_vm._v(_vm._s(_vm.currentStatus))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "vertical-timeline"
  }, _vm._l((_vm.orderTimeList), function(item, index) {
    return _c('div', {
      key: ("order-" + index),
      staticClass: "timeline-item",
      class: {
        'first-item': index === 0
      }
    }, [_c('div', {
      staticClass: "timeline-dot",
      style: ({
        backgroundColor: _vm.getColor(item)
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "timeline-content"
    }, [_c('div', {
      staticClass: "timeline-time"
    }, [_vm._v(_vm._s(item.time))]), _vm._v(" "), _c('div', {
      staticClass: "timeline-title"
    }, [_c('span', {
      staticClass: "operate-type"
    }, [_vm._v(_vm._s(item.operateType))]), _vm._v(" "), _c('span', {
      staticClass: "status-tag",
      class: _vm.getStatusClass(item.operateType)
    }, [_vm._v(_vm._s(item.operateType))])]), _vm._v(" "), _c('div', {
      staticClass: "timeline-desc"
    }, [_c('span', {
      staticClass: "desc-text"
    }, [_vm._v(_vm._s(item.content))])])])])
  }), 0)]), _vm._v(" "), (_vm.repayTimeList.length > 0) ? _c('div', {
    staticClass: "timeline-section"
  }, [_c('div', {
    staticClass: "section-header"
  }, [_vm._m(2), _vm._v(" "), _c('span', {
    staticClass: "record-count"
  }, [_vm._v(_vm._s(_vm.repayTimeList.length) + "条记录")])]), _vm._v(" "), _c('div', {
    staticClass: "vertical-timeline"
  }, _vm._l((_vm.repayTimeList), function(item, index) {
    return _c('div', {
      key: ("repay-" + index),
      staticClass: "timeline-item",
      class: {
        'first-item': index === 0
      }
    }, [_c('div', {
      staticClass: "timeline-dot",
      style: ({
        backgroundColor: _vm.getRepayColor(item)
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "timeline-content"
    }, [_c('div', {
      staticClass: "timeline-time"
    }, [_vm._v(_vm._s(item.time))]), _vm._v(" "), _c('div', {
      staticClass: "timeline-title"
    }, [_c('span', {
      staticClass: "operate-type"
    }, [_vm._v(_vm._s(item.style))]), _vm._v(" "), _c('span', {
      staticClass: "status-tag",
      class: _vm.getRepayStatusClass(item.style)
    }, [_vm._v(_vm._s(item.style))])]), _vm._v(" "), _c('div', {
      staticClass: "timeline-desc"
    }, [_c('span', {
      staticClass: "desc-text"
    }, [_vm._v(_vm._s(item.record))])])])])
  }), 0)]) : _vm._e()]]], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-with-icon"
  }, [_c('i', {
    staticClass: "icon el-icon-s-order"
  }), _vm._v(" "), _c('h5', {
    staticClass: "section-title"
  }, [_vm._v("订单操作记录")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert-icon"
  }, [_c('i', {
    staticClass: "el-icon-warning"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-with-icon"
  }, [_c('i', {
    staticClass: "icon el-icon-money"
  }), _vm._v(" "), _c('h5', {
    staticClass: "section-title"
  }, [_vm._v("还款记录")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b2981fa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/order/orderTime.vue
// module id = 998
// module chunks = 3